module.exports = __webpack_public_path__ + "img/orders.54930898.png";